var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgendarFirmasContratosIndividuales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b3b3b3;}.cls-2{fill:#fff;}.cls-3{fill:#be4047;}.cls-4{fill:#be8244;}.cls-5{fill:#97c8c7;}.cls-6{fill:#4c74b6;}.cls-7{fill:#ce732f;}.cls-8{fill:#ecbe53;}.cls-9{fill:#f7ef66;}.cls-10{fill:#120d0d;}.cls-11{fill:#d4a221;}.cls-12{fill:#424e5c;}.cls-13{fill:#e2b24d;}.cls-14{fill:#f3d585;}.cls-15{fill:#84c2e0;}.cls-16{fill:#f0c93f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agendar_firmas_contratos_individuales") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.25,33.75h87.88A3.26,3.26,0,0,1,119.38,37v74.85a3.26,3.26,0,0,1-3.25,3.26H28.25A3.26,3.26,0,0,1,25,111.86V37A3.26,3.26,0,0,1,28.25,33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.25,33.75h87.88A3.26,3.26,0,0,1,119.38,37v9.76A3.26,3.26,0,0,1,116.13,50H28.25A3.26,3.26,0,0,1,25,46.77V37A3.26,3.26,0,0,1,28.25,33.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38,24v9.76H31.51V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.29,24v9.76H47.78V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38,24v9.76H31.51V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.29,24v9.76H47.78V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.6,24v9.76H90.09V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.87,24v9.76h-6.51V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.6,24v9.76H90.09V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.87,24v9.76h-6.51V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.51,94H54.29v13H31.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.8,61.42h13v9.76h-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.8,77.69h13v9.76h-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.8,94h13v13h-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.87,72.81A14.65,14.65,0,1,1,98.23,58.16,14.64,14.64,0,0,1,112.87,72.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.74,76.06H98.23a1.63,1.63,0,0,1-1.63-1.62V64.67a1.63,1.63,0,0,1,3.25,0v8.14h4.89a1.63,1.63,0,0,1,0,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.88,41.89h3.26v3.26H29.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.39,41.89h3.26v3.26H36.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.15,41.89h3.26v3.26H46.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.66,41.89h3.26v3.26H52.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.31,41.89h3.25v3.26H67.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.82,41.89h3.25v3.26H73.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.46,41.89h3.26v3.26H88.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95,41.89h3.26v3.26H95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.74,41.89H108v3.26h-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.24,41.89h3.26v3.26h-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.53,61.42v9.76h-13V61.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.53,71.18V61.42h9.76L51,66.3l3.25,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M44.53,77.69v9.76h-13V77.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.53,87.45V77.69h9.76L51,82.57l3.25,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.84,94h6.5v13h-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.11,94h6.51v13h-6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.83,105.32,120.36,80.8l6.13,6.13L102,111.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120.36,80.8,124,77.12l6.14,6.13-3.68,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M90.93,110.23l15.94-15.94,6.13,6.13L97.06,116.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M88.48,115.13l3.67-3.68,3.68,3.68-3.68,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M87.25,121.26a1.23,1.23,0,0,1-.87-2.09l2.46-2.45a1.21,1.21,0,0,1,1.71,0,1.23,1.23,0,0,1,0,1.72l-2.45,2.45A1.23,1.23,0,0,1,87.25,121.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M124,77.12l3.68-3.68,6.13,6.13-3.67,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M132.62,78.35l-3.68-3.68L132.65,71l3.65,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M98.63,102.49l1.73-1.73,2.47,2.47L101.1,105Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M102.32,98.83l1.74-1.73,3.68,3.68L106,102.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M105.26,126.17a2.11,2.11,0,0,1-1.4-.5c-1.15-1-.94-2.92.69-6.18a11.13,11.13,0,0,0,.67-1.59,19.64,19.64,0,0,0-3.62,3c-5.28,5.29-13,4.08-13.33,4l.41-2.41c.06,0,6.81,1,11.19-3.34,4.63-4.62,6.32-4.32,7.19-3.7,1.47,1.07.52,3.43-.32,5.12a10.07,10.07,0,0,0-1.13,3.06,7.21,7.21,0,0,0,1.8-1c3.7-2.47,5.21-2.66,5.59-2.66v1.22l.08,1.23s-1.18.17-4.3,2.25A7.32,7.32,0,0,1,105.26,126.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgendarFirmasContratosIndividuales);
export default __webpack_public_path__ + "static/media/agendar_firmas_contratos_individuales.a207ca314404232829d6416c11927a43.svg";
export { ForwardRef as ReactComponent };